export default "__VITE_ASSET__BHV8AHCN__"